/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ILP Content Delivery API
 * API for delivering educational content including course structures and glossaries
 * OpenAPI spec version: v1
 */
import useSwr from "swr";
import type { Key, SWRConfiguration } from "swr";

import type { Error, ListStoryboardsParams, Storyboard } from "../model";

import { apiFetch } from "../../apiFetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListStoryboardsUrl = (params?: ListStoryboardsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/storyboards?${stringifiedParams}`
    : `/api/v1/storyboards`;
};

/**
 * Retrieves storyboards for a specific sub chapter from the local database
 * @summary List storyboards
 */
export const listStoryboards = async (
  params?: ListStoryboardsParams,
  options?: Parameters<typeof apiFetch>[1]
): Promise<Storyboard[]> => {
  return apiFetch<Storyboard[]>(getListStoryboardsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListStoryboardsKey = (params?: ListStoryboardsParams) =>
  [`/api/v1/storyboards`, ...(params ? [params] : [])] as const;

export type ListStoryboardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listStoryboards>>
>;

/**
 * @summary List storyboards
 */
export const useListStoryboards = <TError = unknown>(
  params?: ListStoryboardsParams,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listStoryboards>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof apiFetch>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListStoryboardsKey(params) : null));
  const swrFn = () => listStoryboards(params, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions
  );

  return {
    swrKey,
    ...query,
  };
};
export const getGetStoryboardUrl = (storyboardId: string) => {
  return `/api/v1/storyboards/${storyboardId}`;
};

/**
 * Retrieves storyboard content for a specific content element from the local database
 * @summary Show storyboard content
 */
export const getStoryboard = async (
  storyboardId: string,
  options?: Parameters<typeof apiFetch>[1]
): Promise<Storyboard> => {
  return apiFetch<Storyboard>(getGetStoryboardUrl(storyboardId), {
    ...options,
    method: "GET",
  });
};

export const getGetStoryboardKey = (storyboardId: string) =>
  [`/api/v1/storyboards/${storyboardId}`] as const;

export type GetStoryboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStoryboard>>
>;

/**
 * @summary Show storyboard content
 */
export const useGetStoryboard = <TError = Error>(
  storyboardId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof getStoryboard>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof apiFetch>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false &&
    storyboardId !== null &&
    storyboardId !== undefined;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getGetStoryboardKey(storyboardId) : null));
  const swrFn = () => getStoryboard(storyboardId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions
  );

  return {
    swrKey,
    ...query,
  };
};
